import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer class="">
        <div class="social">
            <a href="https://www.instagram.com/moh_yusrilprayoga/"><i class='bx bxl-instagram bx-md' ></i></a>
            <a href="twitter"><i class='bx bxl-twitter bx-md' ></i></a>
            <a href="facebook"><i class='bx bxl-facebook bx-md' ></i></a>
            <a href="tiktok"><i class='bx bxl-tiktok bx-md' ></i></a>
        </div>

        <div class="link">
            <a href="#home">Home</a>
            <a href="#about">Tentang Kami</a>
            <a href="#menu">Menu</a>
            <a href="#contact">Kontak</a>
        </div>
        

        <div class="credit">
            <p>Created By <a href="https://www.linkedin.com/in/moh-yusril-prayoga-802243238/">Yusril Prayoga</a>. | &copy; 2023.</p>
        </div>
    </footer>
  )
}

export default Footer